<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 120px">
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="pa-0">
                <v-stepper :value="step + 1">
                  <v-stepper-header>
                    <v-stepper-step :complete="step > 0" step="1">{{ steps[0] }}</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2">{{ steps[1] }}</v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col>
            </v-row>

            <!--step 0-->
            <v-row align="start" justify="center" v-if="step == 0">
              <v-col cols="12" md="6" class="mt-4 text-center">
                <p class="fs-16 mb-2">
                  <b>{{ steps[0] }}</b>
                </p>
                <v-label>
                  Descargar la plantilla de importación de legajos.
                  <a class="font-weight-bold ml-1" @click="downloadExcel">Descargar</a>
                </v-label>

                <v-file-input
                  class="mt-3"
                  accept=".xlsx"
                  label="Seleccionar excel"
                  v-model="excelFile"
                  hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                  persistent-hint
                ></v-file-input>
              </v-col>
            </v-row>

            <!--step 1-->
            <v-row align="start" justify="center" v-if="step == 1">
              <v-col md="10" class="mt-4">
                <p class="fs-16 mb-2">
                  <b>{{ steps[1] }}</b>
                </p>
                <v-progress-linear :value="percent" color="blue-grey" height="25" class="mb-3 mt-3">
                  <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                </v-progress-linear>

                <v-data-table :headers="headers" :items="list_bulk" :loading="loading_table" loading-text="Cargando..." :items-per-page="10" dense>
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.object.nro_legajo || "Auto" }}</td>
                      <td>{{ item.object.name }}</td>
                      <td>{{ item.object.surname }}</td>
                      <td>{{ item.object.document_type_name }} {{ item.object.document }}</td>
                      <td>{{ item.object.sucursal_name }}</td>
                      <td>{{ item.object.worksector_name }}</td>
                      <td>{{ item.object.workstation_name }}</td>
                      <td>{{ item.object.hire_date }}</td>
                      <td style="min-width: 200px">
                        <span v-if="item.loading">Procesando...</span>
                        <span v-else-if="item.status == 0">Pendiente de procesado</span>
                        <span v-else-if="item.status_create" class="green--text">
                          Importado
                          <div v-if="item.access_msg" :class="item.access_status ? 'grey--text' : 'orange--text text--darken-3'" style="font-size: 11px">{{ item.access_msg }}</div>
                        </span>
                        <span v-else class="red--text">{{ item.msg }}</span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-0" style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center" no-gutters>
              <v-col cols="10" class="py-3" style="background-color: white">
                <v-btn @click="prev" color="blue-grey" outlined v-if="step > 0" :disabled="loading_create">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-chip color="success" class="mr-2">Importados: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error">Fallidos: {{ importaciones_no_creadas }}</v-chip>
                  <v-btn v-if="importaciones_no_creadas > 0" @click="downloadErrorsExcel" color="error" outlined small class="ml-3">Descargar Errores</v-btn>
                </div>

                <v-btn class="float-right" outlined color="primary" @click="readExcel" v-if="step == 0" :disabled="excelFile == null">Siguiente</v-btn>
              </v-col>
              <v-col cols="12" class="text-right pa-2" style="background-color: #fafafa; border-top: 1px solid #c1c1c1">
                <v-btn color="error" text @click="closeDialog()" :disabled="loading_create">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled || list_bulk.length == 0" :loading="loading_create" v-if="step == 1">Importar</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import ExportMixin from "@/mixins/ExportMixin.vue";
import readXlsxFile from "read-excel-file";
import { LEGAJO_COLUMNS } from "@/constants/ExcelColumnMappings";

export default {
  mixins: [ExportMixin],
  props: {
    modal_title: String,
    dialog: Boolean,
  },
  data() {
    return {
      section: Constant.SECTION_LEGAJOS,
      step: 0,
      steps: ["Importar Excel", "Detalle del Excel"],
      headers: [
        { text: "N° Legajo", align: "left", sortable: true, value: "object.nro_legajo" },
        { text: "Nombre", align: "left", sortable: true, value: "object.name" },
        { text: "Apellido", align: "left", sortable: true, value: "object.surname" },
        { text: "Documento", align: "left", sortable: true, value: "object.document" },
        { text: "Sucursal", align: "left", sortable: true, value: "object.sucursal_name" },
        { text: "Sector", align: "left", sortable: true, value: "object.worksector_name" },
        { text: "Puesto", align: "left", sortable: true, value: "object.workstation_name" },
        { text: "Fecha Ingreso", align: "left", sortable: true, value: "object.hire_date" },
        { text: "Resultado", align: "left", sortable: false, value: "msg" },
      ],
      excelFile: null,
      list_bulk: [],
      loading_create: false,
      loading_table: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      submit_disabled: false,
    };
  },
  computed: {
    percent() {
      if (this.list_bulk.length == 0) return 0;
      return ((this.importaciones_creadas + this.importaciones_no_creadas) * 100) / this.list_bulk.length;
    },
  },
  methods: {
    downloadExcel() {
      this.exportExcel(this.section + "/get-sample-excel", {}, "plantilla_legajos.xlsx");
    },
    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      try {
        const rows = await readXlsxFile(this.excelFile, { sheet: 1 });

        this.list_bulk = rows
          .slice(1)
          .filter((row) => row.some((cell) => cell !== null && cell.toString().trim() !== ""))
          .map((row) => ({
            object: this.parseObject(row),
            msg: "",
            status: 0,
            status_create: false,
            access_msg: null,
            access_status: false,
            loading: false,
          }));
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al leer el archivo Excel", "Error");
      } finally {
        this.loading_table = false;
      }
    },
    toText(value) {
      return value !== null && value !== undefined && value.toString().trim() !== "" ? value.toString().trim() : null;
    },
    toDate(value) {
      if (value instanceof Date) return value.toISOString().split("T")[0];
      return this.toText(value);
    },
    parseObject(row) {
      return {
        nro_legajo: this.toText(row[LEGAJO_COLUMNS.NRO_LEGAJO]),
        name: this.toText(row[LEGAJO_COLUMNS.NOMBRE]),
        surname: this.toText(row[LEGAJO_COLUMNS.APELLIDO]),
        document_type_name: this.toText(row[LEGAJO_COLUMNS.TIPO_DOCUMENTO]),
        document: this.toText(row[LEGAJO_COLUMNS.DOCUMENTO]),
        cuil: this.toText(row[LEGAJO_COLUMNS.CUIL]),
        sucursal_name: this.toText(row[LEGAJO_COLUMNS.SUCURSAL]),
        worksector_name: this.toText(row[LEGAJO_COLUMNS.SECTOR]),
        workstation_name: this.toText(row[LEGAJO_COLUMNS.PUESTO]),
        hire_date: this.toDate(row[LEGAJO_COLUMNS.FECHA_INGRESO]),
        birthdate: this.toDate(row[LEGAJO_COLUMNS.FECHA_NACIMIENTO]),
        gender_name: this.toText(row[LEGAJO_COLUMNS.GENERO]),
        nationality: this.toText(row[LEGAJO_COLUMNS.NACIONALIDAD]),
        civil_status_name: this.toText(row[LEGAJO_COLUMNS.ESTADO_CIVIL]),
        level_study_name: this.toText(row[LEGAJO_COLUMNS.NIVEL_ESTUDIO]),
        disability: this.toText(row[LEGAJO_COLUMNS.DISCAPACIDAD]),
        address: this.toText(row[LEGAJO_COLUMNS.DIRECCION]),
        postal_code: this.toText(row[LEGAJO_COLUMNS.CODIGO_POSTAL]),
        locality: this.toText(row[LEGAJO_COLUMNS.LOCALIDAD]),
        provincia_name: this.toText(row[LEGAJO_COLUMNS.PROVINCIA]),
        phone: this.toText(row[LEGAJO_COLUMNS.TELEFONO]),
        email: this.toText(row[LEGAJO_COLUMNS.EMAIL]),
        external_reference: this.toText(row[LEGAJO_COLUMNS.REFERENCIA_EXTERNA]),
        observations: this.toText(row[LEGAJO_COLUMNS.OBSERVACIONES]),
      };
    },
    closeDialog() {
      if (this.loading_create) return;
      const has_imported = this.importaciones_creadas > 0;
      this.$emit("updateDialog", false);
      if (has_imported) this.$emit("loadList");
      this.resetForm();
    },
    resetForm() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.submit_disabled = false;
      this.loading_create = false;
      this.loading_table = false;
    },
    prev() {
      this.step--;
    },
    async importar() {
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (element.status == 0) {
          element.loading = true;
          const result = await this.createItem(element.object);

          element.loading = false;
          element.status = 1;
          element.status_create = result.status;
          element.access_msg = result.access_msg;
          element.access_status = result.access_status;
          element.msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }
        }
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.$toast.success("Los legajos se importaron correctamente.", "OK");
        this.closeDialog();
      }
    },
    async createItem(item) {
      try {
        const response = await generalService.query(item, this.section + "/import-line");
        return {
          status: response.status,
          msg: response.msg || (response.status ? "Importación exitosa" : "Error en la importación"),
          access_msg: response.access_msg || null,
          access_status: !!response.access_status,
        };
      } catch (error) {
        return { status: false, msg: error.msg || "Error en la importación" };
      }
    },
    downloadErrorsExcel() {
      const errors_data = this.list_bulk
        .filter((item) => item.status === 1 && !item.status_create)
        .map((item) => ({ object: item.object, msg: item.msg }));

      if (errors_data.length === 0) {
        this.$toast.warning("No hay errores para exportar");
        return;
      }

      this.exportExcel(this.section + "/get-excel-with-errors", { errors_data }, "errores_importacion_legajos.xlsx");
    },
  },
};
</script>
